import React from "react";
import { useTranslation } from "react-i18next";

import { Accordion } from "./index";

const KeyTakeaways = ({ isPdf = false, platform, mftPublicTeam }) => {
  const { t } = useTranslation();

  const keyTakeaways = platform === "mft" ?
    t("mft.keyTakeaways", { returnObjects: true }) :
    t("keyTakeaways", { returnObjects: true });

  const content = () => {
    const { description, quickWins = [] } = keyTakeaways?.content || {};

    return (
      <div id="keyTakeaways" className="w-full">
        {!isPdf && (
          <p className="mb-4 text-gray-250" dangerouslySetInnerHTML={{ __html: description }} />
        )}

        {quickWins && quickWins.length > 0 && (
          <div className="flex flex-col gap-4 mt-6">
            {quickWins.map((quickWin, index) => {
              if (!quickWin?.title || !quickWin?.items) return null;

              return (
                <div key={index} className="bg-orange-700 rounded-lg p-4 border border-gray-250/40">
                  <div className="flex gap-4 items-start">
                    {quickWin.icon && (
                      <div className="shrink-0 flex items-center h-12">
                        <span
                          className="w-12 h-12 block"
                          dangerouslySetInnerHTML={{ __html: quickWin.icon }}
                        />
                      </div>
                    )}
                    <div className="flex-1">
                      <h3
                        className="font-semibold text-gray-900 mb-3"
                        dangerouslySetInnerHTML={{ __html: quickWin.title }}
                      />
                      <ul className="list-disc pl-5">
                        {quickWin.items.map((item, itemIndex) => (
                          <li
                            key={itemIndex}
                            className="text-gray-700"
                            dangerouslySetInnerHTML={{ __html: item }}
                          />
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <Accordion
      title={keyTakeaways?.title}
      // icon={keyTakeaways?.icon}
      icon={"<span />"}
      content={content()}
      isPdf={isPdf}
      isStatic={true}
      defaultOpen={true}
      backgroundColor="#ffffff"
    />
  );
};

export default KeyTakeaways;
